import DIApi from './_diApi';

class AccountingObjectCategory extends DIApi {
  controllerName = 'AccountingObjectCategorys';
}
export default new AccountingObjectCategory();
